import React from "react";
import { Dashboard } from "../Pages/Dashboard";
import { Inventory } from "../Pages/Inventory";
import { Products } from "../Pages/Products";
import { Users } from "../Pages/Users";
import { Bars } from "../Pages/Bars";

export function WebPage({
  activePage,
  openCounts,
  activeCount,
  setActiveCount,
}) {
  console.log(openCounts);

  function renderPage(page) {
    switch (page) {
      case "Dashboard":
        return <Dashboard goodName={openCounts} />;
      case "Inventeringar":
        return (
          <Inventory
            activeCount={activeCount}
            setActiveCount={setActiveCount}
          />
        );
      case "Produkter":
        return <Products />;
      case "Användare":
        return <Users />;
      case "Barer":
        return <Bars />;
      default:
        return <Dashboard goodName={openCounts} />;
    }
  }

  return <div className="WebPage">{renderPage(activePage)}</div>;
}
